export default [
    {
        name: 'field',
        title: '攀岩场',
        component: () => import(/* webpackChunkName: "field" */ '../views/RockClimbing/Field/index')
    },
    {
        name: 'fieldLine',
        title: '攀岩场',
        component: () =>
            import(/* webpackChunkName: "fieldLine" */ '../views/RockClimbing/Field/line')
    },
    {
        name: 'feildLineDetail',
        title: '线路详情',
        component: () =>
            import(
                /* webpackChunkName: "feildLineDetail" */ '../views/RockClimbing/Field/lineDetail'
            )
    },
    {
        name: 'fieldLineComment',
        title: '留言',
        component: () =>
            import(
                /* webpackChunkName: "fieldLineComment" */ '../views/RockClimbing/Field/lineComment'
            )
    },
    {
        name: 'fieldCommentDetail',
        title: '详情',
        component: () =>
            import(
                /* webpackChunkName: "fieldCommentDetail" */ '../views/RockClimbing/Field/comment/detail'
            ),
        meta: {
            regMsg: true
        }
    },
    {
        name: 'feildOrder',
        title: '攀岩场排序',
        component: () =>
            import(/* webpackChunkName: "feildOrder" */ '../views/RockClimbing/Field/order'),
        meta: {
            regMsg: true
        }
    },
    {
        name: 'postDetail',
        title: '详情',
        component: () =>
            import(/* webpackChunkName: "postDetail" */ '../views/RockClimbing/Field/postDetail'),
        meta: {
            regMsg: true
        }
    },
    {
        name: 'fieldQingdan',
        title: '攀岩场清单',
        component: () =>
            import(/* webpackChunkName: "fieldQingdan" */ '../views/RockClimbing/Field/qingdan'),
        meta: {
            regMsg: true
        }
    },
    {
        name: 'fieldLuShu',
        title: '路书查询',
        component: () =>
            import(/* webpackChunkName: "fieldLuShu" */ '../views/RockClimbing/Field/lushu'),
        meta: {
            regMsg: true
        }
    },
    {
        name: 'feildBeta',
        title: '视频beta',
        component: () =>
            import(/* webpackChunkName: "fieldLuShu" */ '../views/RockClimbing/Field/beta'),
        meta: {
            regMsg: true
        }
    }
]
